<script setup lang="ts">
import { UiToastHost } from '@acme/ui'
import { useI18n } from 'vue-i18n'
import { RouterView } from 'vue-router'

const { t } = useI18n()
</script>

<template>
  <RouterView />
  <UiToastHost :close-label="t('app.closeNotification')" />
</template>
